import { render, staticRenderFns } from "./AreaRegionForm.vue?vue&type=template&id=34f93b2c&"
import script from "./AreaRegionForm.vue?vue&type=script&lang=js&"
export * from "./AreaRegionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports